import { useState } from "react";
import { ReactComponent as SearchIcon } from "../../../../../assets/icons/aml/search.svg";
import { ReactComponent as CrossIcon } from "../../../../../assets/icons/aml/close.svg";
import "../../../../../css/AML/Inputs/AMLInput1.css";

export default function SearchInput({
  value,
  onChange,
  placeholder = "Search Client Name",
  disabled = false,
  onSubmit,
  label = "",
}) {
  const [focused, setFocused] = useState(false);
  const hasValue = (value ?? "").length > 0;

  const handleChange = (e) => {
    // console.log(e);
    const next = e?.target ? e.target.value : e; // support string or event
    onChange?.(next ?? "");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && onSubmit) onSubmit(value || "");
  };

  const clear = () => onChange?.("");

  return (
    <div className="AML-Input-Container">
      {label && (
        <div className="AML-Input-Label-Container">
          <div className="AML-Text-Body">Address Lookup</div>
        </div>
      )}
      <div className="AML-Input-Icon-Container AML-Input1">
        <input
          className="AML-Text-Body"
          type="text"
          value={value ?? ""}
          onChange={handleChange}
          placeholder={placeholder ||"Enter a postcode/address to search"}
          onKeyDown={handleKeyDown}
        />
        <CrossIcon style={{ cursor: "pointer" }} onClick={clear} />
      </div>
    </div>
  );
}
